import React, { useEffect, useState } from "react";
import { Modal, ModalDialog, Button, Input, Select, Option, Textarea } from "@mui/joy";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { postFetch } from "../../../../../../fetch/fetch";
import styles from "./staffmanage.module.css";
import { NONE_KEY } from "./contractvarkeys";
import { API, toastOptions, errorText } from "./rosterutils";

//줄 편집 (mode edit) / 파트 추가 (mode create — 같은 사람에게 직무 하나 더, 겸직)
//3단계 TODO 페이지가 생기기 전까지 파트·입사일·고보·취득신고·비고를 여기서 입력
const INSURANCE_OPTIONS = [{ value: "", label: "미정" }, { value: "O", label: "O" }, { value: "X", label: "X" }, { value: "해당X", label: "해당X" }];

const PositionEditModal: React.FC<any> = (props) => {

    const [branchKey, setBranchKey] = useState<string>(NONE_KEY);
    const [partId, setPartId] = useState<string>(NONE_KEY);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [employmentInsurance, setEmploymentInsurance] = useState("");
    //취득신고 입력일/이행일 — onboarding JSON (신규직원 TODO 와 같은 값). 저장은 /positions/update 뒤에 바뀐 것만 /todo/stamp
    const [acquisitionInput, setAcquisitionInput] = useState("");
    const [acquisitionDone, setAcquisitionDone] = useState("");
    const [memo, setMemo] = useState("");
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (!props.open) {
            return;
        }
        const p = props.position;
        if (props.mode === "edit" && p) {
            setBranchKey(p.branchKey || NONE_KEY);
            setPartId(p.partId ? String(p.partId) : NONE_KEY);
            setStartDate(p.startDate || "");
            setEndDate(p.endDate || "");
            setEmploymentInsurance(p.employmentInsurance || "");
            setAcquisitionInput(p.onboarding && p.onboarding.acquisitionInput ? String(p.onboarding.acquisitionInput.value || "") : "");
            setAcquisitionDone(p.onboarding && p.onboarding.acquisitionDone ? String(p.onboarding.acquisitionDone.value || "") : "");
            setMemo(p.memo || "");
        } else {
            setBranchKey(NONE_KEY);
            setPartId(NONE_KEY);
            setStartDate("");
            setEndDate("");
            setEmploymentInsurance("");
            setAcquisitionInput("");
            setAcquisitionDone("");
            setMemo("");
        }
        setSaving(false);
    }, [props.open]);

    const save = async () => {
        if (branchKey === NONE_KEY) {
            toast.error("지점을 선택하세요", toastOptions);
            return;
        }
        if (partId === NONE_KEY) {
            toast.error("파트를 선택하세요", toastOptions);
            return;
        }
        if (!startDate) {
            toast.error("입사일을 입력하세요", toastOptions);
            return;
        }
        if (endDate && endDate < startDate) {
            toast.error("퇴사일이 입사일보다 앞섭니다", toastOptions);
            return;
        }
        try {
            setSaving(true);
            const body: any = {
                branchKey,
                partId: +partId,
                startDate,
                endDate: endDate || null,
                employmentInsurance,
                memo
            };
            let result: any;
            if (props.mode === "edit") {
                result = await postFetch(`${API}/positions/update`, { ...body, id: props.position.id });
                if (result.message === "success") {
                    const ob = props.position.onboarding || {};
                    const before = { acquisitionInput: ob.acquisitionInput ? String(ob.acquisitionInput.value || "") : "", acquisitionDone: ob.acquisitionDone ? String(ob.acquisitionDone.value || "") : "" };
                    const after: any = { acquisitionInput, acquisitionDone };
                    for (const key of ["acquisitionInput", "acquisitionDone"]) {
                        if (after[key] !== (before as any)[key]) {
                            const r: any = await postFetch(`${API}/todo/stamp`, { positionId: props.position.id, page: "onboarding", key, value: after[key] || null });
                            if (r.message !== "success") {
                                toast.error(errorText(r, "취득신고 저장에 실패했습니다"), toastOptions);
                            }
                        }
                    }
                }
            } else {
                result = await postFetch(`${API}/positions`, { ...body, userId: props.userId });
            }
            if (result.message === "success") {
                toast.success("저장되었습니다", toastOptions);
                props.onSaved();
                props.onClose();
            } else {
                const map: any = { wrongLocation: "지점 값이 올바르지 않습니다", wrongPart: "파트 값이 올바르지 않습니다", wrongDate: "날짜가 올바르지 않습니다", wrongValue: "값이 올바르지 않습니다" };
                toast.error(map[result.message] || errorText(result, "저장에 실패했습니다"), toastOptions);
            }
        } catch (e) {
            console.log(e);
            toast.error("오류가 발생했습니다", toastOptions);
        } finally {
            setSaving(false);
        }
    };

    const branchOptions: any[] = props.branchOptions || [];
    const parts: any[] = props.parts || [];

    return (
        <Modal open={props.open} onClose={props.onClose}>
            <ModalDialog sx={{ width: "520px", maxWidth: "95vw", maxHeight: "90vh", overflow: "auto" }}>
                <div className={styles.modalTitle}>{props.userName} · {props.mode === "edit" ? "줄 편집" : "파트 추가 (겸직)"}</div>

                <div className={styles.fieldLabel}>지점 (CRM 호점)</div>
                <Select size="sm" value={branchKey} onChange={(e: any, v: any) => { if (v !== null) setBranchKey(v); }}>
                    <Option value={NONE_KEY}>(선택)</Option>
                    {branchOptions.map((b) => <Option key={b.english} value={b.english}>{b.korean}</Option>)}
                </Select>

                <div className={styles.fieldLabel}>파트</div>
                <Select size="sm" value={partId} onChange={(e: any, v: any) => { if (v !== null) setPartId(v); }}>
                    <Option value={NONE_KEY}>(선택)</Option>
                    {parts.map((p) => <Option key={p.id} value={String(p.id)}>{p.name}{!p.templateId ? " (탬플릿 없음)" : ""}</Option>)}
                </Select>

                <div style={{ display: "flex", gap: "12px" }}>
                    <div style={{ flex: 1 }}>
                        <div className={styles.fieldLabel}>입사일</div>
                        <Input size="sm" type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                    </div>
                    <div style={{ flex: 1 }}>
                        <div className={styles.fieldLabel}>퇴사일 (재직 중이면 비움)</div>
                        <Input size="sm" type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                    </div>
                </div>

                <div style={{ display: "flex", gap: "12px" }}>
                    <div style={{ flex: 1 }}>
                        <div className={styles.fieldLabel}>고용보험 적용</div>
                        <Select size="sm" value={employmentInsurance} onChange={(e: any, v: any) => { if (v !== null) setEmploymentInsurance(v); }}>
                            {INSURANCE_OPTIONS.map((o) => <Option key={o.value} value={o.value}>{o.label}</Option>)}
                        </Select>
                    </div>
                    {props.mode === "edit" &&
                        <div style={{ flex: 1 }}>
                            <div className={styles.fieldLabel}>취득신고 입력일 / 이행일</div>
                            <div style={{ display: "flex", gap: "6px" }}>
                                <Input size="sm" type="date" value={acquisitionInput} onChange={(e) => setAcquisitionInput(e.target.value)} sx={{ flex: 1 }} />
                                <Input size="sm" type="date" value={acquisitionDone} onChange={(e) => setAcquisitionDone(e.target.value)} sx={{ flex: 1 }} />
                            </div>
                        </div>
                    }
                </div>

                <div className={styles.fieldLabel}>비고</div>
                <Textarea minRows={3} size="sm" value={memo} onChange={(e) => setMemo(e.target.value)} />

                <div className={styles.modalButtons}>
                    <div className={styles.hint}>{props.mode === "create" ? "같은 사람의 두 번째 직무 — 명부에 줄이 하나 더 생기고 겸직으로 표시됩니다" : ""}</div>
                    <div style={{ display: "flex", gap: "8px" }}>
                        <Button variant="plain" color="neutral" onClick={props.onClose} disabled={saving}>닫기</Button>
                        <Button variant="solid" onClick={save} loading={saving}>저장</Button>
                    </div>
                </div>
            </ModalDialog>
        </Modal>
    );
};

export default PositionEditModal;
